import React, { Fragment, useEffect, useRef, useState } from "react"
import Select from "react-select"
import {
    Button, Card, CardBody, CardSubtitle, CardTitle, Col, Container, Modal, Row, Label
} from "reactstrap"
import apiResponse from "../../../services/apiResponse"
import IndexBloc from "./Blocs/IndexBlock"
import TableActiveComponent from './Components/TableActiveComponent'
import { AvForm, AvField } from "availity-reactstrap-validation"
import moment from 'moment'
import { accessRole } from "../../../helpers/access_role"
import { Link } from "react-router-dom"

var reformatOptions = function (raw, label, value) {
    return raw.map(function (data) {
        var newObj = {};
        newObj["label"] = data[label];
        newObj["value"] = data[value];

        return newObj;
    });
};

const IndexView = (props) => {

    let indexBloc = new IndexBloc();

    const [activeTab, setactiveTab] = useState("1")
    const [modalShowPopupExport, setModalShowPopupExport] = useState(false)
    const activeRef = useRef();
    const inactiveRef = useRef();

    // Select
    const [optionEmpCategories, setOptionEmpCategories] = useState([]);
    const [optionUnits, setOptionUnits] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState("")
    const [selectedEmpCategories, setSelectedEmpCategories] = useState({
        label: 'INTERNAL',
        value: 'f3dd847a-ed83-4539-9a16-7df9048cd42b'
    })
    const [selEmpCategory, setselEmpCategory] = useState("")
    const [selUnit, setselUnit] = useState("")

    //export validation
    const [presensiStartDate, setPresensiStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [presensiEndDate, setPresensiEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

    useEffect(() => {
        // get data unit
        indexBloc.workUnitChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response.result
                        setOptionUnits(
                            reformatOptions(response, 'work_unit_name_tabs', 'work_unit_uuid')
                        )
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        indexBloc.employeeCategoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response.result
                        setOptionEmpCategories(
                            reformatOptions(response, 'employee_categories_name_full', 'employee_categories_uuid')
                        )
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        indexBloc.fetchWorkUnit({})
        indexBloc.fetchEmployeeCategories({})

        return () => {
            indexBloc.workUnitChannel?.unsubscribe()
            indexBloc.employeeCategoriesChannel?.unsubscribe()
        }
    }, [])

    let additionalFilter = {
        emp_categories: selectedEmpCategories.value || "",
        work_unit: selectedUnit.value || "",
        presensi_start_date: presensiStartDate,
        presensi_end_date: presensiEndDate
    };

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const exportActiveRef = () => activeRef.current.exportExcel()
    const exportketidakhadiranActiveRef = () => activeRef.current.exportKetidakhadiranExcel()

    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()

    function handleButtonSearch() {
        reloadActiveRef()
    }

    function handleButtonKetidakhadiranExport() {
        exportketidakhadiranActiveRef();
    }

    function handleButtonExport() {
        exportActiveRef();
    }

    function handleButtonReset() {
        setSelectedUnit('')
        setSelectedEmpCategories('')
        setTimeout(() => {
            reloadActiveRef()
        }, 300);
    }

    function togglePopupExport(status) {
        if (status === 'open') {
            setModalShowPopupExport(true)
        }
        if (status === 'close') {
            setModalShowPopupExport(false)
        }
    }

    function handlerOnExportSubmit() {
        togglePopupExport('close')
        handleButtonExport()
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card>
                            <CardBody>
                                {/* <div className="float-end">
                                {
                                    (accessRole('read')) ?
                                        <Link to="/kepegawaian/presensi.html?simulation">
                                            <Button color="primary">Simulasi</Button>
                                        </Link>
                                    : null
                                }
                                </div> */}
                                <CardTitle>List Data Pegawai</CardTitle>
                                <CardSubtitle className="mb-3">
                                    Daftar Seluruh Pegawai
                                </CardSubtitle>
                                <hr />

                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                        Kategori Pegawai
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionEmpCategories.filter(option =>
                                                option.value === selectedEmpCategories.value)}
                                            onChange={(selectedOption) => {
                                                // Fungsi ini akan dijalankan saat nilai pilihan berubah
                                                setSelectedEmpCategories(selectedOption);
                                                setselEmpCategory(selectedOption.value);
                                                // console.log("Nilai pilihan berubah:", selEmpCategory);
                                              }}
                                            required="required"
                                            options={optionEmpCategories}
                                            classNamePrefix="select2-unit"
                                        />
                                        {/* <Select
                                            value={optionEmpCategories.filter(option =>
                                                option.value === selectedEmpCategories.value)}
                                            onChange={(v) => setSelectedEmpCategories(v)
                                            }
                                            required="required"
                                            options={optionEmpCategories}
                                            classNamePrefix="select2-unit"
                                        /> */}
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="gender"
                                        className="col-md-2 col-form-label"
                                    >
                                        Unit Kerja
                                    </label>
                                    <Col md="4">
                                        <Select
                                            value={optionUnits.filter(option =>
                                                option.value === selectedUnit.value)}
                                            onChange={(selectedOption) => {
                                                // Fungsi ini akan dijalankan saat nilai pilihan berubah
                                                // console.log("Nilai unit kerja pilihan berubah:", selectedOption.value);
                                                setSelectedUnit(selectedOption);
                                                setselUnit(selectedOption.value);
                                              }}
                                            required="required"
                                            options={optionUnits}
                                            classNamePrefix="select2-unit"
                                        />
                                        {/* <Select
                                            value={optionUnits.filter(option =>
                                                option.value === selectedUnit.value)}
                                            onChange={(s) => setSelectedUnit(s)}
                                            required="required"
                                            options={optionUnits}
                                            classNamePrefix="select2-unit"
                                        /> */}
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="10">
                                        <Button
                                            color="primary"
                                            type="button"
                                            onClick={() => {
                                                handleButtonSearch()
                                            }}
                                        >
                                            <i className="uil-search-alt"></i> Cari
                                        </Button>
                                        {' '}
                                        <Button
                                            color="warning"
                                            type="button"
                                            onClick={() => {
                                                handleButtonReset()
                                            }}>
                                            <i className="uil-excel"></i> Reset
                                        </Button>
                                        {' '}
                                        <Button
                                            color="success"
                                            type="button"
                                            onClick={() => {
                                                togglePopupExport('open')
                                            }}
                                        >
                                            Export Kehadiran
                                        </Button>
                                        {/* {' '}
                                        <Button 
                                          color="success" 
                                          type="button"
                                          onClick={() => {
                                              handleButtonKetidakhadiranExport()
                                          }}
                                        >
                                            Export Daftar Ketidakhadiran
                                        </Button> */}
                                        {' '}
                                        {
                                            (accessRole('approve')&& selEmpCategory == '5c2e9672-248b-461d-b75d-c479aa39276c') ?
                                                <Link to="?uploadpresensi">
                                                    <Button color="primary">Upload PTSP</Button>
                                                </Link>
                                            : null
                                        }
                                    </Col>
                                </Row>

                                <hr />

                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef} additionalFilter={additionalFilter} />
                            </CardBody>
                        </Card>


                    </Col>
                </Row>
            </Container>

            <Modal
                size="md"
                isOpen={modalShowPopupExport}
                toggle={() => {

                }}
            >
                <AvForm
                    className="needs-validation"
                    onValidSubmit={() => handlerOnExportSubmit()}
                >
                    <div className="modal-header">
                        <h5 className="modal-title mt-0" id="myModalLabel">
                            Export Kehadiran
                        </h5>
                    </div>
                    <div className="modal-body">
                        <Row className="mb-3">
                            <label
                                className="col-md-6 col-form-label"
                            >
                                Periode Mulai <span className="text-danger">*</span>
                            </label>
                            <Col md="6">
                                <AvField
                                    name="presensi_start_period"
                                    placeholder="Periode Mulai..."
                                    type="date"
                                    errorMessage="Masukkan Periode Mulai"
                                    className="form-control"
                                    onChange={event => setPresensiStartDate(event.target.value)}
                                    id="presensi_start_period"
                                    value={presensiStartDate}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <label
                                className="col-md-6 col-form-label"
                            >
                                Periode Akhir <span className="text-danger">*</span>
                            </label>
                            <Col md="6">
                            <AvField
                                    name="presensi_end_period"
                                    placeholder="Periode Akhir..."
                                    type="date"
                                    errorMessage="Masukkan Periode Akhir"
                                    className="form-control"
                                    onChange={event => setPresensiEndDate(event.target.value)}
                                    id="presensi_end_period"
                                    value={presensiEndDate}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            onClick={() => {
                                togglePopupExport('close')
                            }}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                        >
                            Batal
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary waves-effect waves-light"
                        >
                            Export
                        </button>
                    </div>
                </AvForm>
            </Modal>
        </Fragment>
    )
}

export default IndexView